import React from 'react'
import ListGroup from 'react-bootstrap/ListGroup';
import { MdPerson ,MdThumbUp,MdAddCircleOutline,MdRemoveCircleOutline} from "react-icons/md";
import { MDBBadge, MDBContainer } from "mdbreact";
import LogEvent, {changeFriendList} from './LogEvent'

function FriendItem(props){
    const {myName,myID,userUID,userName, userStatus, userState, isFriend, isMyself} = props;
    console.log(userState);
    console.log(userUID)
    const [iconColor, setIconColor] = React.useState("primary")
    
    React.useEffect(()=>{
        if (userState && userState == "online"){
            setIconColor('green')
        }else{
            setIconColor('primary')
        }
        

    }, [userState])

    //const icon_color = !userState? 'primary' :userState=="offline" ?'primary' : 'green';

    function sendLike(){
        // get the uid for the user 

        // write a record to the personalLog/uid, with messageType 'like'
        console.log("liked")
        // log to friend screen 
        LogEvent(userUID, "like", {
                    senderName : myName,
                    senderID : myID,
                    receiverName : userName

                })
        // log to my screen 
        LogEvent(myID, "like", {
            senderName : myName,
            senderID : myID,
            receiverName : userName

        })
    }

    function addFriend(){
        console.log("addFriend")
        changeFriendList(true, userUID, myID)

    }

    function removeFriend(){
        console.log("removeFriend")
        changeFriendList(false, userUID, myID)

    }

    function chunkStr(astr, num){
        const chunks = []
        

        for (var i = 0; i < astr.length; i += num) {
            chunks.push(astr.slice(i, i+num))
        }
        return chunks
    }
 
    return (

        <ListGroup.Item>
            <div className='friendItem_left_align'>

                <MdPerson style={{ color: iconColor}} /> 
                {userName }
                {/* {
                    (userStatus.length > 13) ?  <br/> : <>{"   "}</>
                } */}
                {"   "}
                { (userState && userState =="online") &&
                <MDBBadge color="success" > {chunkStr(userStatus, 13).map((chunk)=>{
            
                    return <>{chunk} <br/></>
                })}</MDBBadge>}
            
            </div>
            
        
           <div className="friendItem_right_align">
            {(userState && userState =="online" && !isMyself) &&
                    (<>
            
                    
                    
                    <button class="btn friendItem_button" onClick = {()=> sendLike()}><i className="fa fa-folder"></i>
                    <MdThumbUp style ={{textAlign: "right", color:"CornflowerBlue", fontSize: '25px'}}/>
                    
                    </button>
                    
                    
                    </>)
                    
                }
                {/* remove friend icon */}
            
                {(isFriend && !isMyself)&& (
                    <button class="btn friendItem_button" onClick = {()=>removeFriend()}><i className="fa fa-folder"></i>
                    <MdRemoveCircleOutline style ={{textAlign: "right", color:"CornflowerBlue", fontSize: '25px'}}/>
                    </button>
                )
                }

                {(!isFriend && !isMyself)&& (
                    <button class="btn friendItem_button" onClick = {()=>addFriend()}><i className="fa fa-folder"></i>
                    <MdAddCircleOutline style ={{textAlign: "right", color:"CornflowerBlue", fontSize: '25px'}}/>
                    </button>
                )}
            

           </div>
            
            <div className='friendItem_left_align'>
   
            {/* { (userState && userState =="online") &&
                <MDBBadge color="success">{userStatus}</MDBBadge>} */}

            </div>
               

            

            
   
        
        
        </ListGroup.Item>
    )

}

export default FriendItem;